import React, { Component } from 'react';
import { Form, Field, FormSpy } from 'react-final-form';
import pageIconSrc from '../../../src/assets/images/passport-circle.svg';
import arrowLeftSrc from '../../../src/assets/images/arrow-left.svg';
import IndexLink from '../partials/IndexLink';
import { ReactSVG } from 'react-svg';
import { connect } from 'react-redux';
import { messagesSelector, currentThemeSelector } from '../../helpers/selectors';
import { getMessage as t } from '../../utils/utils';
import classnames from 'classnames';
import { PureFileField } from './fields/file';
import { scrollToErrorInfo } from '../../helpers/scrollToError';
import { documentPresent } from '../../helpers/components';

function validate(values = {}, props = {}) {
  const errors = {};

  if (!props.hideFileUpload) {
    if (!documentPresent(values.documentFront)) errors.documentFront = true;
    if (!documentPresent(values.documentBack)) errors.documentBack = true;
  }

  return errors;
}

/**
 * @typedef {object} IdentityDocumentProps
 * @property {boolean} [isSubscribePage=false]
 */
class IdentityDocument extends Component {
  constructor(props) {
    super(props);
    this.lastSubmitFailed = false;
    this.handleSubmitFailedChange = this.handleSubmitFailedChange.bind(this);
  }

  handleSubmitFailedChange({ submitFailed }) {
    if (submitFailed && !this.lastSubmitFailed) {
      scrollToErrorInfo();
    }

    this.lastSubmitFailed = submitFailed;
  }

  getSubmitButtonLabel() {
    const { isSubscribePage, m } = this.props;

    return isSubscribePage ? t(m, 'generic.next') : t(m, 'generic.save');
  }

  displayBackButton() {
    const { isSubscribePage } = this.props;

    if (!isSubscribePage) {
      return (
        <IndexLink to="/profile" className="scope-content-header-button-return">
          <ReactSVG className="react-svg" src={arrowLeftSrc} />
        </IndexLink>
      );
    }
  }

  render() {
    const {
      m,
      onSubmit,
      initialValues,
      userDataUpdating,
      hideFileUpload,
      theme
    } = this.props;

    const { identityDocument } = theme.icons || {};
    const boundValidate = (values) => validate(values, this.props);

    return (
      <Form onSubmit={onSubmit} initialValues={initialValues} validate={boundValidate}>
        {({ handleSubmit }) => (
          <form className="identity-document-page" onSubmit={handleSubmit} noValidate>
            <FormSpy
              subscription={{ submitFailed: true }}
              onChange={this.handleSubmitFailedChange}
            />
            <div className="scope-content-header">
              <img
                className="scope-content-header-picture"
                src={identityDocument ? identityDocument : pageIconSrc}
                alt="page icon"
              />
              <div className="scope-content-header-title-container">
                {this.displayBackButton()}
                <div className="scope-content-header-title">
                  {t(m, 'label.identity_card')}
                </div>
              </div>
            </div>
            <div className="scope-content-body">
              <div className="scope-section">
                {hideFileUpload ? (
                  <div className="scope-section-fields">
                    <div className="scope-field-container">
                      <div className="scope-info-text">
                        {t(m, 'label.file.upload.only.mobile')}
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="scope-section-fields">
                    <Field
                      name="documentFront"
                      label={t(m, 'label.identity_card_front')}
                      mandatory
                      component={PureFileField}
                    />
                    <Field
                      name="documentBack"
                      label={t(m, 'label.identity_card_back')}
                      mandatory
                      component={PureFileField}
                    />
                  </div>
                )}
              </div>
            </div>
            {!hideFileUpload && (
              <div className="scope-content-footer">
                <button
                  type="submit"
                  className={classnames('scope-submit-button', 'primary-btn', {
                    'sub-class-disabled': userDataUpdating
                  })}
                >
                  {this.getSubmitButtonLabel()}
                </button>
              </div>
            )}
          </form>
        )}
      </Form>
    );
  }
}

IdentityDocument.defaultProps = {
  isSubscribePage: false
};


const mapStateToProps = (state) => {
  const { userDataUpdating } = state.user;

  return {
    m: messagesSelector(state),
    userDataUpdating,
    theme: currentThemeSelector(state)
  };
};

export default connect(mapStateToProps)(IdentityDocument);
